import React from "react";
import { Award, Users, ShieldCheck, Trophy } from "lucide-react";
import { stats } from "../mock";

const iconMap = [Trophy, Award, Users, ShieldCheck];

export default function StatsBar() {
  return (
    <section className="bg-neutral-900 text-white bg-dotted-dark">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((s, i) => {
          const Icon = iconMap[i % iconMap.length];
          return (
            <div key={i} className="flex items-center gap-4">
              <span className="w-14 h-14 rounded-full bg-orange-500/10 ring-1 ring-orange-500/40 flex items-center justify-center text-orange-500">
                <Icon size={26} />
              </span>
              <div>
                <p className="font-display text-3xl md:text-4xl font-bold leading-none text-orange-500">{s.value}</p>
                <p className="uppercase tracking-wider text-xs md:text-sm text-neutral-300 mt-2">{s.label}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
